const ENV_NEXT_PUBLIC_ROOT_URL = process.env.NEXT_PUBLIC_ROOT_URL // API ROOT URL
const ENV_NEXT_PUBLIC_REGION = process.env.NEXT_PUBLIC_REGION // REGION TO USE ("global", "scandinavia")
const ENV_NEXT_PUBLIC_GA_TM_ID = process.env.NEXT_PUBLIC_GA_TM_ID // GOOGLE TAG MANAGER ID
const ENV_NEXT_PUBLIC_MATOMO_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID // MATOMO SITE ID
const ENV_NEXT_PUBLIC_MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL // MATOMO BASE URL (e.g. https://analytics.example.com/)
const ENV_NEXT_PUBLIC_IS_DEV = process.env.NEXT_PUBLIC_IS_DEV // IS DEV

const ROOT_URL_FALLBACK = 'http://127.0.0.1:8001'//'http://nemo.willandskill.eu:8110' //'https://api.investoract.com' //
const REGION_FALLBACK = 'scandinavia'
const GA_TM_ID_FALLBACK = 'GTM-TWW22BDN'
const MATOMO_SITE_ID_FALLBACK = '1'
const MATOMO_URL_FALLBACK = 'https://analytics.willandskill.se/'
const IS_DEV_FALLBACK = false

const REGIONS = {
  GLOBAL: 'global', // Not used anylonger, but might be necessary in the future
  SCANDINAVIA: 'scandinavia',
  UAE: 'uae'
}

const ROOT_URL = ENV_NEXT_PUBLIC_ROOT_URL || ROOT_URL_FALLBACK
const IS_DEV = ENV_NEXT_PUBLIC_IS_DEV == "true" || IS_DEV_FALLBACK
const REGION = ENV_NEXT_PUBLIC_REGION || REGION_FALLBACK

const COUNTRY_UAE_ID = 9
const COUNTRY_SWEDEN_ID = 1

const REGION_SETTINGS_LIST = {
  uae: {
    startUrl: '/uae',
    domain: 'https://www.investoract.com',
    brand: {
      name: 'InvestorAct',
      shortDescription: 'Stay ahead of of the curve with our daily financial updates!',
      description: 'InvestorAct is a financial news platform that provides the latest news, analysis, and press releases for companies in the UAE',
      brandNameAndSymbol: '/images/brand-name-and-symbol.svg',
      brandSymbol: '/images/brand-symbol.svg'
    },
    countryId: COUNTRY_UAE_ID,
    ads: {
      sunt: {
        showOnOverviewPage: false,
        showOnECList: false,
        showOnECListModulo: 3,
      }
    }

  },
  scandinavia: {
    startUrl: '/sv',
    domain: 'https://www.bors360.com',
    brand: {
      name: 'Börs360',
      shortDescription: 'Håll dig uppdaterad med de senaste analyserna!',
      description: 'Senaste analyserna, nyheterna, pressmeddelande för bolag i Sverige',
      brandNameAndSymbol: '/images/bors360/brand-name-and-symbol-white.svg',
      brandSymbol: '/images/bors360/brand-symbol-white.svg'
    },
    countryId: COUNTRY_SWEDEN_ID,
    ads: {
      sunt: {
        showOnOverviewPage: false,
        showOnECList: false,
        showOnECListModulo: 3,
      }

    }
  }
}

const REGION_SETTINGS = REGION_SETTINGS_LIST[REGION]
const GA_TM_ID = ENV_NEXT_PUBLIC_GA_TM_ID || GA_TM_ID_FALLBACK
const MATOMO_SITE_ID = ENV_NEXT_PUBLIC_MATOMO_SITE_ID || MATOMO_SITE_ID_FALLBACK
const MATOMO_URL = ENV_NEXT_PUBLIC_MATOMO_URL || MATOMO_URL_FALLBACK

const BRAND = REGION_SETTINGS.brand
const DOMAIN = REGION_SETTINGS.domain
const AD_SETTINGS = REGION_SETTINGS.ads
const START_URL = REGION_SETTINGS.startUrl
const COUNTRY_ID = REGION_SETTINGS.countryId

const CACHE_SETTINGS = {
  REVALIDATE_PAGE_DEFAULT: 60 * 60 * 24, // 24 hours
  REVALIDATE_MAIN_PAGE: 60 * 60 * 6, // 6 hour (was 15m)
  REVALIDATE_EDITORIAL_CONTENT_LIST: 60 * 60 * 3, // 3 hours (was 10m)
  REVALIDATE_EDITORIAL_CONTENT_DETAIL: 60 * 60 * 24 * 30, // 30 days
  REVALIDATE_INSTRUMENT_THREAD_LIST: 60 * 60 * 3, // 3 hours
  FETCH_CACHE: 60 * 60, // 1 hour
  FETCH_EDITORIAL_CONTENT_LIST: 60 * 60 * 12, // 12 hours
  FETCH_EDITORIAL_CONTENT_DETAIL: 60 * 60 * 24 * 30, // 30 days
  FETCH_THREAD_LIST: 60 * 60 * 3, // 3 hours
  FETCH_INSTRUMENT_THREAD_LIST: 60 * 60 * 3, // 3 hours
  FETCH_CONNECTED_TO_STOCK_LIST: 60 * 60 * 3, // 3 hours
  FETCH_CONNECTED_TO_PORTFOLIO_LIST: 60 * 60 * 3, // 3 hours
  FETCH_CONNECTED_TO_TRANSACTION_LIST: 60 * 60 * 3, // 3 hours
  FETCH_CONNECTED_TO_PUBLICATION_LIST: 60 * 60 * 3, // 3 hours
  FETCH_PORTFOLIO_THREAD_LIST: 60 * 60 * 3, // 3 hours
  FETCH_PORTFOLIO_THREAD_WALL_LIST: 60 * 60 * 3, // 3 hours
  FETCH_INSTRUMENT_WALL_THREAD_LIST: 60 * 60 * 3, // 3 hours
}



const URL_SWEDEN_PREFIX = 'sv'
const URL_UAE_PREFIX = 'uae'

const LANGUAGES = {
  SWEDISH: 'sv',
  ENGLISH: 'en-gb'
}
const LANGUAGE = REGIONS.SCANDINAVIA === REGION ? LANGUAGES.SWEDISH : LANGUAGES.ENGLISH

export {
  AD_SETTINGS,
  BRAND,
  CACHE_SETTINGS,
  COUNTRY_SWEDEN_ID,
  COUNTRY_UAE_ID,
  COUNTRY_ID,
  DOMAIN,
  GA_TM_ID,
  IS_DEV,
  LANGUAGE,
  MATOMO_SITE_ID,
  MATOMO_URL,
  REGION,
  REGIONS,
  ROOT_URL,
  START_URL,
  URL_SWEDEN_PREFIX,
  URL_UAE_PREFIX,

}